module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('h2', {
    staticClass: "Verse-head",
    attrs: {
      "id": "_idParaDest-12"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor012"
    }
  }), _vm._v("Brat Gospel")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("A teenage mum, her little brat")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("born loving, crucified, cut down.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Glory all around.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("Such goings-on ")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("survive as symbols: slain lamb,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("a sickle, an all-seeing eye.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("Heavy lumps of history")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("blacken the surrounding sky.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Blind giants with feet of clay.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("Looking on")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("we hear the heartfelt cry:")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("make way for the royal lamb!")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("The eye compassionate, ")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("visionary of the Christ-life")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("rooted in the hearts of all.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36ea8c1c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781398400801_EPUB-14.vue
// module id = 99
// module chunks = 0